import { observer } from 'mobx-react-lite';
import React, { PropsWithChildren } from 'react';

import classNames from 'classnames';
import styles from './PreviewFrame.css';

export const PreviewFrame = observer(function _PreviewFrame({
  children,
  bordered,
}: PropsWithChildren<{ bordered?: boolean }>) {
  return (
    <div className={classNames(styles.container, bordered && styles.bordered)}>
      <div className={styles.header}>
        <div className={classNames(styles.pip, styles.red)} />
        <div className={classNames(styles.pip, styles.yellow)} />
        <div className={classNames(styles.pip, styles.green)} />
      </div>
      <div className={classNames(styles.content)}>{children}</div>
    </div>
  );
});
